const common = {
  site_name: 'OOPBuy Spreadsheet',
  tagline: 'Finde die besten Produkte schneller',
};

export default common;